import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, Fragment as _Fragment } from "vue";
const _hoisted_1 = { class: "clearfix" };
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("h3", { class: "mt-0 mb-4" }, "Battery Life Prediction Settings", -1 /* HOISTED */);
const _hoisted_3 = { class: "col-xs-12 col-sm-6 col-md-6 bottom10" };
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("label", null, "\r\n\t\t\t\tOhmic Rise Limit For Block Replacement (%)\r\n\t\t\t", -1 /* HOISTED */);
const _hoisted_5 = { class: "invalid-feedback" };
const _hoisted_6 = { class: "col-xs-12 col-sm-6 col-md-6 bottom10" };
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("label", null, "\r\n\t\t\t\t% Of Blocks Above Ohmic Rise (%) Limit For String Replacement\r\n\t\t\t", -1 /* HOISTED */);
const _hoisted_8 = { class: "invalid-feedback" };
const _hoisted_9 = {
    key: 0,
    class: "col-xs-12 col-sm-6 col-md-6 bottom10"
};
const _hoisted_10 = /*#__PURE__*/ _createElementVNode("label", null, "\r\n\t\t\t\tMinimum Ohmic Rise % To Use Prediction\r\n\t\t\t", -1 /* HOISTED */);
const _hoisted_11 = { class: "invalid-feedback" };
const _hoisted_12 = {
    key: 0,
    class: "clearfix"
};
const _hoisted_13 = /*#__PURE__*/ _createElementVNode("h3", { class: "mt-0 mb-4" }, "Issues", -1 /* HOISTED */);
const _hoisted_14 = { class: "col-xs-12 col-sm-12 col-md-6" };
const _hoisted_15 = { class: "checkbox-wrapper bottom10" };
const _hoisted_16 = { class: "ms-3" };
const _hoisted_17 = { class: "bottom10" };
const _hoisted_18 = /*#__PURE__*/ _createElementVNode("label", null, "\r\n\t\t\t\t\t\tIssue Description for Ohmic Critical Alarm\r\n\t\t\t\t\t", -1 /* HOISTED */);
const _hoisted_19 = /*#__PURE__*/ _createElementVNode("small", { class: "form-text text-muted" }, "\r\n\t\t\t\t\t\tDefault wording is used if not set.\r\n\t\t\t\t\t", -1 /* HOISTED */);
const _hoisted_20 = /*#__PURE__*/ _createElementVNode("label", null, "\r\n\t\t\t\t\t\tTask Description for Ohmic Critical Alarm\r\n\t\t\t\t\t", -1 /* HOISTED */);
const _hoisted_21 = /*#__PURE__*/ _createElementVNode("small", { class: "form-text text-muted" }, "\r\n\t\t\t\t\t\tDefault wording is used if not set.\r\n\t\t\t\t\t", -1 /* HOISTED */);
const _hoisted_22 = { class: "col-xs-12 col-sm-12 col-md-6" };
const _hoisted_23 = { class: "checkbox-wrapper bottom10" };
const _hoisted_24 = { class: "ms-3" };
const _hoisted_25 = { class: "bottom10" };
const _hoisted_26 = /*#__PURE__*/ _createElementVNode("label", null, "\r\n\t\t\t\t\t\tIssue Description for Amb. Temperature Critical Alarm\r\n\t\t\t\t\t", -1 /* HOISTED */);
const _hoisted_27 = /*#__PURE__*/ _createElementVNode("small", { class: "form-text text-muted" }, "\r\n\t\t\t\t\t\tDefault wording is used if not set.\r\n\t\t\t\t\t", -1 /* HOISTED */);
const _hoisted_28 = /*#__PURE__*/ _createElementVNode("label", null, "\r\n\t\t\t\t\t\tTask Description for Amb. Temperature Critical Alarm\r\n\t\t\t\t\t", -1 /* HOISTED */);
const _hoisted_29 = /*#__PURE__*/ _createElementVNode("small", { class: "form-text text-muted" }, "\r\n\t\t\t\t\t\tDefault wording is used if not set.\r\n\t\t\t\t\t", -1 /* HOISTED */);
const _hoisted_30 = {
    key: 1,
    class: "clearfix"
};
const _hoisted_31 = /*#__PURE__*/ _createElementVNode("h3", { class: "mt-0 mb-4" }, "Services", -1 /* HOISTED */);
const _hoisted_32 = { class: "col-xs-12 col-sm-6 col-md-6" };
const _hoisted_33 = { class: "checkbox-wrapper bottom10" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_form_input = _resolveComponent("b-form-input");
    const _component_b_form_checkbox = _resolveComponent("b-form-checkbox");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createElementVNode("div", _hoisted_1, [
            _hoisted_2,
            _createTextVNode(),
            _createElementVNode("div", _hoisted_3, [
                _hoisted_4,
                _createTextVNode(),
                _createVNode(_component_b_form_input, _mergeProps(_ctx.ohmicRiseLimitForBlockReplacementVal, {
                    type: "number",
                    modelValue: _ctx.batteryLifePredictionSettingsModel.ohmicRiseLimitForBlockReplacement,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.batteryLifePredictionSettingsModel.ohmicRiseLimitForBlockReplacement) = $event)),
                    modelModifiers: { trim: true },
                    class: { 'is-invalid': _ctx.errors && _ctx.errors.ohmicRiseLimitForBlockReplacement },
                    min: "1",
                    max: "100"
                }), null, 16 /* FULL_PROPS */, ["modelValue", "class"]),
                _createTextVNode(),
                _withDirectives(_createElementVNode("div", _hoisted_5, "\r\n\t\t\t\t* Please enter a valid value between 1 and 100\r\n\t\t\t", 512 /* NEED_PATCH */), [
                    [_vShow, _ctx.errors && _ctx.errors.ohmicRiseLimitForBlockReplacement]
                ])
            ]),
            _createTextVNode(),
            _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                _createTextVNode(),
                _createVNode(_component_b_form_input, _mergeProps(_ctx.percOfBlocksAboveOhmicRiseLimitForStringReplacementVal, {
                    type: "number",
                    modelValue: _ctx.batteryLifePredictionSettingsModel.percOfBlocksAboveOhmicRiseLimitForStringReplacement,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.batteryLifePredictionSettingsModel.percOfBlocksAboveOhmicRiseLimitForStringReplacement) = $event)),
                    modelModifiers: { trim: true },
                    class: { 'is-invalid': _ctx.errors && _ctx.errors.percOfBlocksAboveOhmicRiseLimitForStringReplacement },
                    min: "1",
                    max: "100"
                }), null, 16 /* FULL_PROPS */, ["modelValue", "class"]),
                _createTextVNode(),
                _withDirectives(_createElementVNode("div", _hoisted_8, "\r\n\t\t\t\t* Please enter a valid value between 1 and 100\r\n\t\t\t", 512 /* NEED_PATCH */), [
                    [_vShow, _ctx.errors && _ctx.errors.percOfBlocksAboveOhmicRiseLimitForStringReplacement]
                ])
            ]),
            _createTextVNode(),
            (_ctx.isPowerShield)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _hoisted_10,
                    _createTextVNode(),
                    _createVNode(_component_b_form_input, _mergeProps(_ctx.minOhmicRiseToUsePredictionVal, {
                        type: "number",
                        modelValue: _ctx.batteryLifePredictionSettingsModel.minOhmicRiseToUsePrediction,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.batteryLifePredictionSettingsModel.minOhmicRiseToUsePrediction) = $event)),
                        modelModifiers: { trim: true },
                        class: { 'is-invalid': _ctx.errors && _ctx.errors.minOhmicRiseToUsePrediction },
                        min: "1",
                        max: "100"
                    }), null, 16 /* FULL_PROPS */, ["modelValue", "class"]),
                    _createTextVNode(),
                    _withDirectives(_createElementVNode("div", _hoisted_11, "\r\n\t\t\t\t* Please enter a valid value between 1 and 100\r\n\t\t\t", 512 /* NEED_PATCH */), [
                        [_vShow, _ctx.errors && _ctx.errors.minOhmicRiseToUsePrediction]
                    ])
                ]))
                : _createCommentVNode("v-if", true)
        ]),
        _createTextVNode(),
        (_ctx.isAdministrator)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _hoisted_13,
                _createTextVNode(),
                _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                        _createVNode(_component_b_form_checkbox, {
                            modelValue: _ctx.issueSettingsModel.createIssueForOhmicCriticalAlarm,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.issueSettingsModel.createIssueForOhmicCriticalAlarm) = $event)),
                            size: "lg"
                        }, {
                            default: _withCtx(() => [
                                _createTextVNode("\r\n\t\t\t\t\tCreate an Issue When Ohmic Critical Alarm is Raised\r\n\t\t\t\t")
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["modelValue"])
                    ]),
                    _createTextVNode(),
                    _withDirectives(_createElementVNode("div", _hoisted_16, [
                        _createElementVNode("div", _hoisted_17, [
                            _hoisted_18,
                            _createTextVNode(),
                            _createVNode(_component_b_form_input, _mergeProps(_ctx.ohmicCriticalAlarmDescriptionVal, {
                                modelValue: _ctx.issueSettingsModel.ohmicCriticalAlarmDescription,
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.issueSettingsModel.ohmicCriticalAlarmDescription) = $event)),
                                modelModifiers: { trim: true },
                                maxlength: 250,
                                class: { 'is-invalid': _ctx.errors && _ctx.errors.ohmicCriticalAlarmDescription }
                            }), null, 16 /* FULL_PROPS */, ["modelValue", "class"]),
                            _createTextVNode(),
                            _hoisted_19,
                            _createTextVNode(),
                            _withDirectives(_createElementVNode("div", { class: "invalid-feedback" }, _toDisplayString(_ctx.errors.ohmicCriticalAlarmDescription), 513 /* TEXT, NEED_PATCH */), [
                                [_vShow, _ctx.errors && _ctx.errors.ohmicCriticalAlarmDescription]
                            ])
                        ]),
                        _createTextVNode(),
                        _createElementVNode("div", null, [
                            _hoisted_20,
                            _createTextVNode(),
                            _createVNode(_component_b_form_input, _mergeProps(_ctx.ohmicCriticalAlarmTaskVal, {
                                modelValue: _ctx.issueSettingsModel.ohmicCriticalAlarmTask,
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_ctx.issueSettingsModel.ohmicCriticalAlarmTask) = $event)),
                                modelModifiers: { trim: true },
                                maxlength: 250,
                                class: { 'is-invalid': _ctx.errors && _ctx.errors.ohmicCriticalAlarmTask }
                            }), null, 16 /* FULL_PROPS */, ["modelValue", "class"]),
                            _createTextVNode(),
                            _hoisted_21,
                            _createTextVNode(),
                            _withDirectives(_createElementVNode("div", { class: "invalid-feedback" }, _toDisplayString(_ctx.errors.ohmicCriticalAlarmTask), 513 /* TEXT, NEED_PATCH */), [
                                [_vShow, _ctx.errors && _ctx.errors.ohmicCriticalAlarmTask]
                            ])
                        ])
                    ], 512 /* NEED_PATCH */), [
                        [_vShow, _ctx.issueSettingsModel.createIssueForOhmicCriticalAlarm]
                    ])
                ]),
                _createTextVNode(),
                _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, [
                        _createVNode(_component_b_form_checkbox, {
                            modelValue: _ctx.issueSettingsModel.createIssueForAmbTempCriticalAlarm,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_ctx.issueSettingsModel.createIssueForAmbTempCriticalAlarm) = $event)),
                            size: "lg"
                        }, {
                            default: _withCtx(() => [
                                _createTextVNode("\r\n\t\t\t\t\tCreate an Issue When Amb. Temperature Critical Alarm is Raised\r\n\t\t\t\t")
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["modelValue"])
                    ]),
                    _createTextVNode(),
                    _withDirectives(_createElementVNode("div", _hoisted_24, [
                        _createElementVNode("div", _hoisted_25, [
                            _hoisted_26,
                            _createTextVNode(),
                            _createVNode(_component_b_form_input, _mergeProps(_ctx.ambTempCriticalAlarmDescriptionVal, {
                                modelValue: _ctx.issueSettingsModel.ambTempCriticalAlarmDescription,
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((_ctx.issueSettingsModel.ambTempCriticalAlarmDescription) = $event)),
                                modelModifiers: { trim: true },
                                maxlength: 250,
                                class: { 'is-invalid': _ctx.errors && _ctx.errors.ambTempCriticalAlarmDescription }
                            }), null, 16 /* FULL_PROPS */, ["modelValue", "class"]),
                            _createTextVNode(),
                            _hoisted_27,
                            _createTextVNode(),
                            _withDirectives(_createElementVNode("div", { class: "invalid-feedback" }, _toDisplayString(_ctx.errors.AmbTempCriticalAlarmDescription), 513 /* TEXT, NEED_PATCH */), [
                                [_vShow, _ctx.errors && _ctx.errors.ambTempCriticalAlarmDescription]
                            ])
                        ]),
                        _createTextVNode(),
                        _createElementVNode("div", null, [
                            _hoisted_28,
                            _createTextVNode(),
                            _createVNode(_component_b_form_input, _mergeProps(_ctx.ambTempCriticalAlarmTaskVal, {
                                modelValue: _ctx.issueSettingsModel.ambTempCriticalAlarmTask,
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((_ctx.issueSettingsModel.ambTempCriticalAlarmTask) = $event)),
                                modelModifiers: { trim: true },
                                maxlength: 250,
                                class: { 'is-invalid': _ctx.errors && _ctx.errors.ambTempCriticalAlarmTask }
                            }), null, 16 /* FULL_PROPS */, ["modelValue", "class"]),
                            _createTextVNode(),
                            _hoisted_29,
                            _createTextVNode(),
                            _withDirectives(_createElementVNode("div", { class: "invalid-feedback" }, _toDisplayString(_ctx.errors.AmbTempCriticalAlarmTask), 513 /* TEXT, NEED_PATCH */), [
                                [_vShow, _ctx.errors && _ctx.errors.ambTempCriticalAlarmTask]
                            ])
                        ])
                    ], 512 /* NEED_PATCH */), [
                        [_vShow, _ctx.issueSettingsModel.createIssueForAmbTempCriticalAlarm]
                    ])
                ])
            ]))
            : _createCommentVNode("v-if", true),
        _createTextVNode(),
        (_ctx.isAdministrator)
            ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                _hoisted_31,
                _createTextVNode(),
                _createElementVNode("div", _hoisted_32, [
                    _createElementVNode("div", _hoisted_33, [
                        _createVNode(_component_b_form_checkbox, {
                            modelValue: _ctx.companyServicesSettingsModel.isAssurePlusCustomer,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((_ctx.companyServicesSettingsModel.isAssurePlusCustomer) = $event)),
                            size: "lg"
                        }, {
                            default: _withCtx(() => [
                                _createTextVNode("\r\n\t\t\t\t\tIs AssurePlus customer\r\n\t\t\t\t")
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["modelValue"])
                    ])
                ])
            ]))
            : _createCommentVNode("v-if", true)
    ], 64 /* STABLE_FRAGMENT */));
}
